export enum Path {
  ADMIN = '/admin',
  ADMIN_USERS = '/admin/users',
  ADMIN_VIEW_PROFILE = '/admin/profile',
  ADMIN_MANAGE_CONTENT = '/admin/manage-content',
  ADMIN_MANAGE_CONTENT_NOTE_TEMPLATE = '/admin/manage-content/note-templates',
  ADMIN_MANAGE_CONTENT_NOTE_TEMPLATE_REVISION = '/admin/manage-content/note-template-revisions',
  ADMIN_TECH_OPS = '/admin/tech-ops',
  CALENDAR = '/maud/calendar',
  CALENDAR_AVAILABILITY = '/maud/calendar/availability',
  CALENDAR_GROUP_CLASS = '/maud/calendar/groups',
  CALENDAR_GROUP = '/maud/calendar/groups_v2',
  CALENDAR_INTEGRATION = '/maud/calendar/integration',
  CALENDAR_SCHEDULE = '/maud/calendar/schedule',
  HOME = '/',
  LOGIN = '/login',

  MAUD = '/maud',
  MAUD_ANALYTICS = '/maud/analytics',
  MAUD_INQUIRIES = '/maud/inquiries',
  MAUD_PATIENTS = '/maud/patients',
  MAUD_PRESCRIPTIONS = '/maud/prescriptions',
  MAUD_SURVEYS = '/maud/surveys',
  MAUD_TASKS = '/maud/tasks',
  OPS = '/ops',
  OPS_SCRIPTSURE_SYNC_DASHBOARD = '/ops/scriptsure-sync-dashboard',
  OPS_VIEW_PROFILE = '/ops/profile',
  PORTAL = '/portal',
  SETTINGS = '/maud/settings',
  VIEW_PROFILE = '/maud/profile',
}

export const logInMethodKey = 'LOG_IN_METHOD_KEY';
export const loggedInEventTrackedKey = 'LOGIN_EVENT_TRACKED';
export const bootstrapErrorKey = 'BOOTSTRAP_ERROR';
export enum LoginMethod {
  USERNAME_PASSWORD = 'Username/Password',
  JUMPCLOUD_SSO = 'Jumpcloud SSO',
}
export enum LogoutMethod {
  IDLE_LOGOUT = 'Idle Logout',
  MANUAL_LOGOUT = 'Manual Logout',
}
